import { tick } from "svelte";

export class Mask2Handler { //Enhanced to use regex like abilities for masking

}
export class MaskHandler {
    private mask: string = '';
    private inputMask: string = '';
    private inputEl: HTMLInputElement | null = null;
    private overridden: boolean = false;
    private onInputHandler!: (ev: Event) => void;
    private onInteractHandler!: (ev: Event) => void;
    constructor(mask: string, inputEl: HTMLInputElement) {
        if (mask && mask.length > 0 && inputEl) {
            this.mask = mask;
            this.inputMask = getInputMask(this.mask);
            this.inputEl = inputEl;
            this.overridden = false;
            //Add hooks
            this.onInputHandler = this.onInput.bind(this);
            this.onInteractHandler = this.onInteract.bind(this);
            this.inputEl.addEventListener('input', this.onInputHandler);
            this.inputEl.addEventListener('click', this.onInteractHandler);

            // this.inputEl.addEventListener('input', this.onInput.bind(this));
            // this.inputEl.addEventListener('click', this.onInteract.bind(this));
            //remove any max length because it doesn't work with masking
            if (this.inputEl.attributes.getNamedItem('maxlength'))
                this.inputEl.attributes.removeNamedItem('maxlength');
            //Setup mask attributes
            this.inputEl.setAttribute('placeholder', this.mask);
            this.inputEl.setAttribute('mask', this.inputMask);
        }
    }

    disable() {
        if (!this.inputEl) return;
        this.inputEl.removeEventListener('input', this.onInputHandler);
        this.inputEl.removeEventListener('click', this.onInteractHandler);
    }

    enable() {
        if (!this.inputEl) return;
        this.inputEl.addEventListener('input', this.onInputHandler);
        this.inputEl.addEventListener('click', this.onInteractHandler);
    }

    override(value: string): string {
        if (!this.inputEl) return '';
        this.disable();
        this.inputEl.value = value;
        this.overridden = true;
        setTimeout(() => {
            this.enable();
        }, 1);
        return value;
    }

    onInput(ev: Event) {
        const e = ev as InputEvent;
        const value = this.handleInputEvent(e); // Use the mask parameter
    }

    onInteract(ev: Event) {
        if (!this.inputEl) return;
        const e = ev as InputEvent;
        let caretPos = this.inputEl.selectionStart || 0; // Assuming inputEl is your input element

        //Manage caret position
        if (!/[a9*]/.test(this.mask[caretPos])) {
            // Find the next position where Mask character is 'a', '*' or '9'
            for (let i = caretPos + 1; i < this.mask.length; i++) {
                if (/[a9*]/.test(this.mask[i])) {
                    caretPos = i;
                    break;
                }
            }
        }
        // Set the new caret position
        this.inputEl.setSelectionRange(caretPos, caretPos);
    }

    handleInputEvent(
        e: InputEvent,
    ) {
        if (!this.inputEl) return;
        this.overridden = false;
        let caretPos = this.inputEl.selectionStart || 0;
        let inputVal = this.inputEl.value;
        let el = this.inputEl;
        //console.log("#######", inputVal, caretPos, e.data, e.inputType);
        // Detect backspace event
        if (e.inputType === 'deleteContentBackward' && caretPos > 0 && !/[a9*]/.test(this.mask[caretPos])) {
            // Move the caret backward to the closest user-enterable position ('a', '*', or '9')
            for (let i = caretPos - 1; i >= 0; i--) {
                if (/[a9*]/.test(this.mask[i])) {
                    caretPos = i;
                    break;
                }
            }
            // Remove the user-entered character at the new caretPos, if any
            if (/[a9*]/.test(this.mask[caretPos])) {
                inputVal = inputVal.substring(0, caretPos) + inputVal.substring(caretPos + 1);
            }
        }
        //e.data is undefined during autocomplete, null during backspace or deletion, single value during typing and multiple values during paste
        //e.inputType is undefined during autocomplete
        if (e.data === undefined && e.inputType === undefined) {
            //if autocomplete is "tel" and input length is 11 and first num is 1 then remove 1
            if (el.getAttribute('autocomplete') == 'tel') {
                if (el.value[0] == '+') {
                    inputVal = el.value = el.value.substring(1)
                }
                if (el.value.length == 11 && el.value[0] == '1') {
                    inputVal = el.value = el.value.substring(1)
                }
            }
        }
        if (el.value.length > this.mask.length && e.data && e.data.length == 1) {
            inputVal = el.value.substring(0, caretPos) + el.value.substring(caretPos + 1);
        }
        //Save caret position
        const caretAtEnd = caretPos == inputVal.length;
        const addedTextLength = e.data?.length || 1;
        let outputStr = '';
        let i = 0;
        let matchedAValue = false;
        let addedCharsAfterCaret = 0;
        let filledOut = false;

        //On first input insert any beginning characters from the mask
        for (; i < this.mask.length; i++) {
            if (/[^a9*]/.test(this.mask[i]) && inputVal[i] != this.mask[i] && this.mask[i] != inputVal[0]) {
                outputStr += this.mask[i];
                addedCharsAfterCaret++;
                continue;
            }
            break;
        }

        // Iterate over each character in the mask and match it with the corresponding input character
        let inputIndex = 0;
        let setCaretPos = false;
        for (; i < this.mask.length; i++) {
            const maskChar = this.mask[i];
            const inputChar = inputVal[inputIndex];
            if (/[^a9*]/.test(maskChar)) {
                if (maskChar == inputChar) {
                    outputStr += inputChar;
                    if (i >= caretPos) {
                        addedCharsAfterCaret++;
                    }
                    inputIndex++;
                    continue;
                }
            }
            if (inputIndex >= inputVal.length && this.inputMask) {
                if (!setCaretPos) {
                    if (this.inputMask[i] == '_') {
                        caretPos = i;
                        setCaretPos = true;
                    }
                }
                outputStr += this.inputMask[i];
                continue;
            }

            if (maskChar === 'a' && /[a-zA-Z]/.test(inputChar)) {
                outputStr += inputChar;
                matchedAValue = true;
                inputIndex++;
            } else if (maskChar === '9' && /\d/.test(inputChar)) {
                outputStr += inputChar;
                matchedAValue = true;
                inputIndex++;
            } else if (maskChar === '*' && /[a-zA-Z0-9]/.test(inputChar)) {
                outputStr += inputChar;
                matchedAValue = true;
                inputIndex++;
            } else if (/[^a9*]/.test(maskChar)) {
                // Allow for characters like '(', ')', '-', and ' ' in the mask
                // if (i >= caretPos) {
                // 	//addedCharsAfterCaret++;
                // }
                outputStr += maskChar;
            } else {
                // If the input character doesn't match the mask, skip it
                inputIndex++;
                i--;
            }
            //console.log(outputStr, '-', inputChar);
        }
        console.log("Setting el.value to ", outputStr);
        let phoneEl = document.getElementById("TextInput_phone")

        tick().then(() => {
            el.value = outputStr;
            // setTimeout(() => {
            //     el.value = outputStr;
            // }, 1);
            // phoneEl.value = outputStr
            // console.log("The value is now: ", this.inputEl.value);
            // console.log("this.inputEl", this.inputEl)
            // console.log("el", el)
            // console.log("document.getElementById(TextInput_phone)", document.getElementById("TextInput_phone"))
            // //Wait 2 seconds
            // setTimeout(() => {
            //     phoneEl.value = "Testing"
            //     //delete this.inputEl from dom (id = TextInput_phone)
            //     //wait 2 seconds
            //     setTimeout(() => {
            //         console.log("deleting")
            //         document.getElementById("TextInput_phone")?.remove()
            //     }, 2000);
            // }, 2000);

            if (this.inputEl.value.length > this.mask.length) {
                this.onInteract(e);
            } else {
                //Manage caret position
                if (!/[a9*]/.test(this.mask[caretPos])) {
                    // Find the next position where Mask character is 'a', '*' or '9'
                    for (let i = caretPos + 1; i < this.mask.length; i++) {
                        if (/[a9*]/.test(this.mask[i])) {
                            caretPos = i;
                            break;
                        }
                    }
                }

                el.setSelectionRange(caretPos, caretPos);
            }
        })
        return outputStr;
        if (!matchedAValue || caretAtEnd) {
            //console.log('setting caret position to end', el.value.length);
            //el.setSelectionRange(el.value.length, el.value.length);
            //el.selectionStart = el.selectionEnd = outputStr.length - 1;
        } else if (!e.data) {
            el.setSelectionRange(caretPos, caretPos);
        } else if (addedTextLength >= 1) {
            while (true) {
                if (caretPos > mask.length - 1) {
                    break;
                }
                if (/[^a9*]/.test(mask[caretPos - 1])) {
                    caretPos++;
                } else {
                    break;
                }
            }
            console.log('addedCharsAfterCaret', addedCharsAfterCaret);
            console.log('setting caret position', caretPos + addedTextLength);
            el.setSelectionRange(caretPos, caretPos);
        }
        return outputStr;
    }
    getValue() {
        if (!this.inputEl) return;
        if (!this.mask) {
            return '';
        }

        if (this.overridden) {
            return this.inputEl.value;
        }
        const rawInput = this.inputEl.value;
        let outputStr = '';

        // Iterate over each character in the mask and match it with the corresponding input character
        let inputIndex = 0;
        for (let i = 0; i < this.mask.length && inputIndex < rawInput.length; i++) {
            const maskChar = this.mask[i];
            const inputChar = rawInput[i];

            if (maskChar === 'a' && /[a-zA-Z]/.test(inputChar)) {
                outputStr += inputChar;
            } else if (maskChar === '9' && /\d/.test(inputChar)) {
                outputStr += inputChar;
            } else if (maskChar === '*' && /[a-zA-Z0-9]/.test(inputChar)) {
                outputStr += inputChar;
            } else if (/[()\- ]/.test(maskChar)) {
                // Allow for characters like '(', ')', '-', and ' ' in the mask
                //outputStr += maskChar;
            }
        }
        return outputStr;
    }
}

export function getDataFromMask(mask: string, input: string) {
    const rawInput = input;
    let outputStr = '';

    // Iterate over each character in the mask and match it with the corresponding input character
    let inputIndex = 0;
    for (let i = 0; i < mask.length && inputIndex < rawInput.length; i++) {
        const maskChar = mask[i];
        const inputChar = rawInput[i];

        if (maskChar === 'a' && /[a-zA-Z]/.test(inputChar)) {
            outputStr += inputChar;
        } else if (maskChar === '9' && /\d/.test(inputChar)) {
            outputStr += inputChar;
        } else if (maskChar === '*' && /[a-zA-Z0-9]/.test(inputChar)) {
            outputStr += inputChar;
        } else if (/[()\- ]/.test(maskChar)) {
            // Allow for characters like '(', ')', '-', and ' ' in the mask
            //outputStr += maskChar;
        }
    }
    return outputStr;
}

export function getInputMask(mask: string) {
    return mask.replaceAll(/[a9*]/g, '_');
}
